import React from 'react';
import { Section, Stack } from '@fiverr-private/layout_components';
import { Typography, Link } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { I18n } from '@fiverr-private/i18n-react';
import SafeComponent from '../../../logged_out_homepage/shared/SafeComponent';
import { getKnowledgeHubItems } from './utils';

const KnowledgeHub = () => {
    const knowledgeHubItems = getKnowledgeHubItems();

    return (
        <Section paddingTop="0" paddingBottom="0">
            <Stack direction="column" gap="10" marginBottom="10">
                <Typography style={{ fontWeight: 400 }} letterSpacing="-0.03em" as="h2">
                    <I18n k="logged_out_homepage.de.knowledge_hub.title" />
                </Typography>
                <Stack
                    display="flex"
                    alignItems="center"
                    direction={{ default: 'column', sm: 'row' }}
                    gap={{ default: '10', md: '9' }}
                    maxWidth="100%"
                >
                    {knowledgeHubItems.map(({ title, src, link }) => (
                        <Stack key={title} direction="column" gap="6" borderRadius="2xl">
                            <Link href={link} target="_blank" rel="noreferrer" decoration="none">
                                <Image alt={title} src={src} />
                            </Link>
                            <Typography fontSize="b_lg" fontWeight="bold">
                                {title}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>
            </Stack>
        </Section>
    );
};

export default SafeComponent(KnowledgeHub);
